// src/components/FlipCard.jsx
import React from "react";
import "../FlipCard.css";

const FlipCard = ({
    frontIcon,
    frontTitle,
    backText,
    borderColor,
}) => {
    return (
        <div className="flip-card">
            <div className="flip-card-inner">
                {/* Front Side */}
                <div
                    className="flip-card-front"
                    style={{
                        border: `2px solid ${borderColor}`,
                        color: borderColor,
                    }}
                >
                    <img src={frontIcon} alt={frontTitle} />
                    <h3>{frontTitle}</h3>
                </div>

                {/* Back Side */}
                <div
                    className="flip-card-back"
                    style={{
                        backgroundColor: borderColor,
                    }}
                >
                    <div className="flip-card-back-content text-gray-200 text-sm text-center px-3">
                        {backText}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FlipCard;

    // const position = [21.2127, 72.8516]; 